import React, { Component, Fragment } from 'react';

import * as Func from '../../../../../../helpers/functions';
import DEFINE, { DATE_TIME_FORMAT, ORDER, PATHS } from '../../../../../../constants/Define';
import {
    FormWrapperItem, ListComponent,
} from "../../../../common/component/Index";
import { ShowDetailGroupComponent, DetailOrderGroupVoucher } from '../../component/CommonComponent';
import Wrapper from "../../../../common/component/Wrapper";
import Span from "../../../../common/component/Span";
import { Skeleton } from 'antd';
import Order, { OrderVoucherItem } from '../../../../../../models/Order';
import Model from '../../../../../../constants/Model';
import EllipsisText from '../../../../common/component/EllipsisText';
import { Tooltip, Icon } from 'antd';
import * as HMS from "../../../../common/component/Index";
import { getMomentDate } from '../../../../../../utils/commonUtils';
import SurchargeInfo from '../SurchargeInfo/SurchargeInfo';
import DetailStatusItem from '../DetailStatusItem';


import './VoucherInfo.less';
import PopupFlight from '../PopupFlight';
import Text from 'antd/lib/typography/Text';

const OrderVoucherItemKeys = Object.getOwnPropertyNames(new OrderVoucherItem());
const statusDisabledChange = [4, 5, 13]
export default class VoucherInfo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            titleOrderItemTable: Func.getTitleTable(['action', ...OrderVoucherItemKeys],  ['flightInfo'], ['orderId', 'itemVariantId', 'quantity', 'productVariantId', 'voucherType', 'detail', 'isLocked', 'rateCodeId']),
            modelOrderItem: OrderVoucherItemKeys,
            componentTable: {
                groupName: {
                    width: 300,
                    render: (text, record) => <EllipsisText title={text} content={text} contentMaxWidth={280}
                        overlayClassName={'max-width-500'} overlayComponent={Tooltip} />
                },
                rateCode: {
                    key: 'rateCode',
                    render: (rateCode, record)=>{
                        return <div className="ratecode-open-new" onClick={()=> this.onOpenRateCode(record)}>
                                {record.rateCode}
                            </div>
                    }
                },
                discountValue: {
                    width: 150,
                    render: this.renderDiscountValue,
                },
                originalPrice: {
                    render: (text, record) => Func.formatMoney(record.originalPrice || '') + this.props.t('currencySymbol')
                },
                salePrice: {
                    render: (text, record) => Func.formatMoney(record.salePrice || '') + this.props.t('currencySymbol')
                },
                serialNumber: {
                    width: 300
                },
                propertyOfStay: {
                    render: (text, record) => text && text.name
                },
                property: {
                    render: (text, record) => text && text.name
                },
                checkInDate: {
                    render: (date) => date && getMomentDate(date).format(DATE_TIME_FORMAT.SHORT_DATE),
                },
                checkOutDate: {
                    render: (date) => date && getMomentDate(date).format(DATE_TIME_FORMAT.SHORT_DATE),
                },
                checkedDate: {
                    render: (date) => date && getMomentDate(date).format(DATE_TIME_FORMAT.SHORT_DATE),
                },
                status: {
                    key: 'status',
                    render: (value, record) => {
                        let status = value;
                        if (record.isExpired) {
                            status = 999;
                        }
                        return status && <Fragment>
                            <HMS.StatusComponent color={this.props.t(`item.order.orderItemStatusColor.${status}`)}
                                label={this.props.t(`item.order.orderItemStatus.${value}`)} />
                            {record.isLocked && <Icon type="lock" style={{ color: 'red' }} />}
                        </Fragment>
                    },
                },
                action: {
                    width: 100,
                    // fixed: 'right',
                    align: 'center',
                    render: (text, record) => <Fragment>
                        {/* <ShowDetailGroupComponent item={record} order={this.props.order}
                            onShowDetailGroupVoucher={(i) => this.onShowDetailGroupVoucher(i, record)} /> */}
                        { !statusDisabledChange.includes(record.status) && this.props.permisions.allowChangeStatus && 
                        <Tooltip title={this.props.t(`action.changeStatus`)} placement="top">
                            <Icon type="edit" className="fs20 colorPrimary" onClick={() => this.onClickChangeStatus(record)} />
                        </Tooltip>
                        }
                        {this.props.allowSurcharge && 
                            <Tooltip title={this.props.t(`action.newSurchange`)} placement="top">
                                <Icon type="file-add" className="fs20 colorPrimary" onClick={() => this.props.createModalSurcharge(record.itemVariantId, ORDER.TYPES.VOUCHER.id)} />
                            </Tooltip>
                        }
                        {
                            record.status === 2 && this.props.permisions.allowLockItem && 
                            <Tooltip title={this.props.t(`action.${record.isLocked ? 'unlockItem' : 'lockItem'}`)} placement="top">
                                <Icon type={`${record.isLocked ? 'unlock' : 'lock'}`} className="fs20 colorPrimary" onClick={() => this.onLockItem(record)} />
                            </Tooltip>
                        }
                        {
                            record.rateCodeId && record.status !== 3 && <Tooltip title={this.props.t(`action.changeRateCote`)} placement="top">
                                <Icon type="retweet" className="fs20 colorPrimary" onClick={() => this.props.onChangeRateCode(record.rateCodeId, record.itemVariantId, 1)} />
                            </Tooltip>
                        }
                    </Fragment>
                },
                flightInfo: {
                    key: 'flightInfo',
                    align: 'center',
                    render: (tour, record) => {
                        const flightTrackingOrderItem = (this?.props?.orderState?.detail?.flightTrackingOrder || []).find(el => el.itemVariantId === record?.itemVariantId);
                        return(<Wrapper>
                            <Text className='cursor-pointer' underline onClick={() => this.handleOpenPopupFlight(record.itemVariantId)}>{flightTrackingOrderItem?.airlineNumber ?? 'Thêm chuyến bay'}</Text>
                            {(this.state.showPopupFlightInfo && this.state.showPopupFlightInfo===record.itemVariantId) && <PopupFlight 
                                            handleClosePopupFlight={this.handleClosePopupFlight}
                                            t={this.props.t}
                                            selectFilterSearch={this.selectFilterSearch}
                                            airportDeparture={this.props.airportDeparture}
                                            airportArrival={this.props.airportArrival}
                                            airlineDomestic={this.props.airlineDomestic}
                                            tour={record}
                                            order={this.props.orderState.detail.order}
                                            permissions={this.props.permissionFlightTracking}
                                            createFlightTracking={this.props.createFlightTracking}
                                            updateFlightTracking={this.props.updateFlightTracking}
                                            deleteFlightTracking={this.props.deleteFlightTracking}
                                            flightTrackingOrderItem={flightTrackingOrderItem}
                                        />}
                        </Wrapper>)
                    }
                }
            },
            showDetailGroupVoucher: false,
            expandedRows: [],
            dataItem: null,
            showPopupFlightInfo: null
        };
    };
    componentDidMount(){
        this.props.getListFlightTrackingOrder(this.props.orderId);
    }

    render() {
        const { t, vouchers, voucherItems, loading, loadingList, filters } = this.props;
        const { titleOrderItemTable, modelOrderItem, componentTable, showDetailGroupVoucher, expandedRows, dataItem } = this.state;

        return (
            <Wrapper className="tour-info-section col-md-12 mb-3">
                <h3 className={`ml-0`}>{t('item.order.voucherInfo')}</h3>
                <Wrapper className={`row mt-2`}>
                    {!loading ?
                        <FormWrapperItem classParent="p-0" classChildren="m-0 p-0">
                            <ListComponent
                                scroll={{ x: 2500 }}
                                classParent="m-0 p-0 col-md-12"
                                marginTop={'0'} marginBottom={'0'}
                                loading={{ spinning: loading, size: 'large' }}
                                rowKey={(record, k) => k}
                                dataSource={Func.getDataSource(vouchers || [], modelOrderItem)}
                                columns={Func.columnsTable({
                                    titleTable: titleOrderItemTable,
                                    component: componentTable,
                                    itemName: 'order.voucher'
                                })}
                                pagination={{ total: filters.totalCount, totalPage: filters.totalPage }}
                                componentTableList={{}}
                                hideSettings={true}
                                expandedRowRender={this.renderSurcharge}
                                onExpand={this.onRowExpanded}
                                onColumnVisibleChange={this.onColumnVisibleChange}
                                expandedRowKeys={expandedRows}
                                onExpandedRowsChange={expandedRows => this.setState({ expandedRows })}
                            />
                        </FormWrapperItem>
                        : <Skeleton active paragraph={{ row: 7 }} />
                    }
                </Wrapper>
                {
                    showDetailGroupVoucher && (
                        <DetailOrderGroupVoucher
                            // isSubmit={isSubmit}
                            // data={data}
                            vouchers={voucherItems}
                            filters={filters}
                            isFetching={loadingList}
                            onClose={(i) => this.setState({ showDetailGroupVoucher: i })}
                            onChange={(e) => this.onPaginateDetailGroup(e)}
                            pagination={filters}
                            // onSubmit={this.onSubmit}
                            showDetailGroupVoucher={showDetailGroupVoucher}
                        />
                    )
                }
                <DetailStatusItem 
                    title={`${t('item.order.changeStatus')} ${t('item.voucher.title').toLowerCase()}`}
                    visible={!!dataItem}
                    onSave={this.onSaveStatus}
                    itemTypes={ORDER.TYPE_ITEM['1']}
                    onClose={() => this.setState({ dataItem: null })}
                    item={dataItem || {}}
                    keyName={'groupName'}
                />
            </Wrapper>
        );
    }

    renderSurcharge = (record, index, indent, expanded) => {
        return (
            <SurchargeInfo
                listType='vouchers'
                removeSurcharge={this.props.removeSurcharge}
                surcharges={record.detail.items}
                loading={false}
                openModalDetail={this.props.openDetailSurcharge}
            />
        )
    }

    onRowExpanded = (expanded, record) => {
        if (expanded && record.itemVariantId) {
            this.props.onItemExpanded(expanded, record, 'vouchers')
        }
    }

    renderDiscountValue = (text, voucher) => {
        switch (voucher.voucherType) {
            case DEFINE.GENERAL.VOUCHER_TYPE.GIFT:
                return this.props.t(`item.order.voucher.types.${voucher.voucherType}`);
            case DEFINE.GENERAL.VOUCHER_TYPE.PERCENT:
                return text + this.props.t(`item.order.voucher.types.${voucher.voucherType}`);
            case DEFINE.GENERAL.VOUCHER_TYPE.MONEY:
                return this.props.t(`item.order.voucher.types.${voucher.voucherType}`) + ` ${Func.formatMoney(text)}${this.props.t('currencySymbol')}`;
            default:
                return '';
        }
    }

    onShowDetailGroupVoucher = (params, item) => {
        this.setState({ showDetailGroupVoucher: true, groupId: item.productVariantId })
        this.props.onGetDetailVoucher(params);
    };

    onPaginateDetailGroup = (params) => {
        this.props.onGetDetailVoucher({
            id: this.props.order.id,
            filters: {
                ...params,
                groupId: this.state.groupId
            }
        })
    };

    handleOpenPopupFlight = (id) => {
        this.setState({
            showPopupFlightInfo: id
        })
    }
    handleClosePopupFlight = () => {
        this.setState({
            showPopupFlightInfo: null
        })
    }

    selectFilterSearch = (input, option) => {
        const optionText = Func.vietnameseStringToUnicode(option?.props?.children?.toString().toLowerCase());
        const inputText = Func.vietnameseStringToUnicode(input.toLowerCase());
        return optionText.indexOf(inputText) >= 0;
    }

    onColumnVisibleChange = () => {

    }

    onClickChangeStatus = (item) => {
        this.setState({ dataItem: item })
    }

    onSaveStatus = (orderItem) => {
        if(this.props.onUpdateItem){
            orderItem.orderItemType = 1;
            this.props.onUpdateItem(orderItem)
        }
        this.setState({ dataItem: null })
    }

    onLockItem = (orderItem) => {
        orderItem.orderItemType = 1;
        this.props.showConfirmLockItem(orderItem, orderItem.groupName)
    }

    onOpenRateCode = (data)=>{
        window.open(`${PATHS.RATECODE.CREATE.path}/${data.rateCodeId}`);
    }
}

VoucherInfo.defaultProps = {
    onGetDetailVoucher: (voucher) => { },
    order: new Order(),
    voucherItems: [],
    loading: false,
    loadingList: false,
    data: {},
    filters: {},
};